import Info from '../../components/common/Info';
import SubInfo from '../../components/common/SubInfo';
import GapAround from '../../components/hoc/GapAround';
import ExpertiseCard from '../../components/common/ExpertiseCard';
import { imageUrl } from '../../utils';
import { useMediaQuery } from '@mui/material';

// Both rows share one animated element, so they can never drift out of column with each other.
// That element is a strip of columns, each holding `rowCount` stacked cards.
const toColumns = (items: any[], rowCount: number) => {
  // A partly filled trailing column would leave a hole in the loop, so repeat the list until
  // it divides evenly into columns.
  const filled = items.length % rowCount === 0 ? items : [...items, ...items];
  return Array.from({ length: Math.ceil(filled.length / rowCount) }, (_, column) =>
    filled.slice(column * rowCount, (column + 1) * rowCount),
  );
};

const SECONDS_PER_COLUMN = 3.75;

const OurExpertise = ({ title, description, displayItems = [] }: any) => {
  const isLessThan1280 = useMediaQuery('(max-width: 1280px)');
  const isLessThan640 = useMediaQuery('(max-width: 640px)');
  const columns = toColumns(displayItems, isLessThan640 ? 1 : 2);
  return (
    <div className="outline relative outline-[1px] outline-gray-200" id="expertise">
      <div className="">
        <div
          className="bg-top absolute w-full h-full -z-10 opacity-10"
          style={{ backgroundImage: `url(${imageUrl('lightbulb.svg')})`}}></div>
        <GapAround childrenClasses="flex flex-col breaktwomin:flex-row h-full justify-center items-center">
          <div
            className={`left_part w-full breaktwomin:w-[30%] xl:w-full h-full py-10 space-y-2 text-center breaktwomin:text-left flex flex-col justify-center breaktwo:py-6 mobile:px-4`}>
            <Info variant={"h2"} typographyStyles={{ color: '#263238', fontSize: isLessThan1280 ? (isLessThan640 ? 32 : 36) : 42 }}>
              {title}
            </Info>
            <SubInfo typographyStyles={{ color: '#728F8B' }}>{description}</SubInfo>
          </div>
          <div className="right_part w-[40%] xl:w-[60%] breaktwo:w-[90%] flex items-center mobile:w-full mobile:px-4 breaktwomin:pl-12">
            <div className="expertise-marquee overflow-hidden w-full">
              <div
                className="expertise-marquee-track flex w-max"
                style={{ animationDuration: `${columns.length * SECONDS_PER_COLUMN}s` }}>
                {[...columns, ...columns].map((column, columnIndex) => (
                  <div
                    key={`expertise-column-${columnIndex}`}
                    aria-hidden={columnIndex >= columns.length}
                    className="shrink-0 flex flex-col">
                    {column.map((item, index) => (
                      <ExpertiseCard
                        key={`expertise-${columnIndex}-${index}`}
                        containerClasses="w-[200px] outline outline-[.5px] outline-gray-200"
                        {...item}
                      />
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </GapAround>
      </div>
    </div>
  );
};

export default OurExpertise;
